import { z } from 'zod';
import { US_STATE_CODES } from './states.js';
export const FieldTypeSchema = z.enum([
    'text',
    'textarea',
    'number',
    'currency',
    'percentage',
    'date',
    'datetime',
    'boolean',
    'select',
    'multiselect',
    'tags',
    'email',
    'url',
    'states',
    'user',
    'confidence',
    'status',
]);
export const FieldDefinitionSchema = z.object({
    key: z.string().min(1).max(64).regex(/^[a-zA-Z][a-zA-Z0-9_]*$/),
    label: z.string().min(1).max(128),
    type: FieldTypeSchema,
    required: z.boolean().optional().default(false),
    defaultValue: z.unknown().optional(),
    helpText: z.string().max(512).optional(),
    placeholder: z.string().max(128).optional(),
    options: z.array(z.string()).optional(),
    searchable: z.boolean().optional(),
    filterable: z.boolean().optional(),
    sortable: z.boolean().optional(),
    tableVisible: z.boolean().optional(),
    detailVisible: z.boolean().optional(),
    tooltipVisible: z.boolean().optional(),
    readOnly: z.boolean().optional(),
    min: z.number().optional(),
    max: z.number().optional(),
    maxLength: z.number().int().positive().optional(),
});
export const ColorBucketSchema = z.object({
    min: z.number().nullable(),
    max: z.number().nullable(),
    label: z.string(),
    color: z.string().optional(),
});
export const ColorRuleSchema = z.object({
    type: z.enum([
        'recordCount',
        'sum',
        'average',
        'category',
        'status',
        'boolean',
        'confidence',
        'freshness',
        'assigned',
    ]),
    field: z.string().nullable().optional(),
    buckets: z.array(ColorBucketSchema).optional(),
});
export const FreshnessConfigSchema = z.object({
    currentDays: z.number().int().positive(),
    reviewSoonDays: z.number().int().positive(),
    staleDays: z.number().int().positive(),
});
export const MapDefinitionSchema = z.object({
    mapId: z
        .string()
        .min(1)
        .max(64)
        .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
    name: z.string().min(1).max(128),
    description: z.string().max(1024).default(''),
    recordLabel: z.string().min(1).max(64).default('Record'),
    version: z.number().int().positive().default(1),
    status: z.enum(['active', 'archived']).default('active'),
    fields: z.array(FieldDefinitionSchema).min(1),
    filters: z.array(z.string()).default([]),
    tableColumns: z.array(z.string()).default([]),
    tooltipFields: z.array(z.string()).default([]),
    detailFields: z.array(z.string()).default([]),
    colorRule: ColorRuleSchema.optional(),
    freshness: FreshnessConfigSchema.optional(),
    createdAt: z.string().datetime().optional(),
    createdBy: z.string().email().optional(),
    updatedAt: z.string().datetime().optional(),
    updatedBy: z.string().email().optional(),
});
export const MapSummarySchema = z.object({
    mapId: z.string(),
    name: z.string(),
    description: z.string(),
    status: z.enum(['active', 'archived']),
    recordLabel: z.string().optional(),
});
export const UsStateCodeSchema = z.enum(US_STATE_CODES);
//# sourceMappingURL=map-definition.js.map